import { gql } from '@/__generated__';

export const GET_LAST_CONNECTION_STATE = gql(`#graphql
  query GetLastConnectionState($movementId: Int!) {
    gateMovement(id: $movementId) {
      gate {
        id
        mainDevice {
          id
          metrics {
            id
            connectionState {
              lastData
            }
          }
        }
      }
    }
  }
`);
